import { Zap, Disc3, Target, Flame, Palmtree, Heart, Moon, Sun, Sunset, PartyPopper, Sparkles, Crown, AudioLines } from 'lucide-react';

// Icon + neon color per vibe. The API still carries an emoji for admin use;
// students see these instead. Colors stay off the four class colors (purple,
// blue, yellow, green) so a vibe never reads as an instrument.
const NEON = { lime: '#A2FF00', pink: '#FF3DA5', cyan: '#00FFDD', orange: '#FF8A00', red: '#FF4D5E', coral: '#FF7A59' };

const VIBES = {
  'big-energy': [Zap, NEON.lime],
  'bounce-vibe': [Disc3, NEON.pink],
  'calm-focus': [Target, NEON.cyan],
  'trap-energy': [Flame, NEON.orange],
  'afro-chill': [Palmtree, NEON.lime],
  'warm-rnb': [Heart, NEON.pink],
  'dark-drill': [Moon, NEON.red],
  'latin-pop': [Sun, NEON.orange],
  'latin-warm': [Sunset, NEON.coral],
  'reggaeton-bounce': [PartyPopper, NEON.cyan],
  'playful-pop': [Sparkles, NEON.pink],
  'confident-grind': [Crown, NEON.lime],
};

export const vibeStyle = (id) => {
  const [Icon, color] = VIBES[id] || [AudioLines, NEON.cyan];
  return { Icon, color };
};
